import { ENDPIONTS, Operation, PaginatedResult, httpService } from "@api";
import { PaperHeader } from "@components";
import { useFetch } from "@hooks";
import { Termination } from "@models";
import { Action, ComplexHeader, ExportData, Filterable, Table, TableVerticalConfigs } from "@shared";
import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const ListTerminations = () => {
  const [queryStrings] = useSearchParams();
  const navigate = useNavigate();

  const fetchData = useFetch<PaginatedResult<Termination>>(
    {
      endPoint: ENDPIONTS.terminations,
      queryStrings:queryStrings
    },
    new PaginatedResult<Termination>()
  );

  useEffect(() => {}, [fetchData?.isFetching]);

  const headers: ComplexHeader[] = [
    { key: "employeeId", title: "employee Id" },
    { key: "employeeName", title: "employee" },
    { key: "reason", title: "reason" },
    { key: "remarks", title: "remarks" },
    // { key: "createdBy", title: "createdBy" },
    { key: "createdAt", title: "createdAt", format: "date" },
  ];

  const actions: Action[] = [
    {
      key: "",
      actionType: "badge",
      click: (l: Termination) => window.open(l.path),
      title: "View",
      color: "dark",
      disable: (v: Termination) => v.path === null,
    },
  ];

  const filters: Filterable<any>[] = [
    { key: "createdAt", title: "created at", format: "dateRange" },
    {
      key: "employeeName",
      title: "employee name",
      format: "text",
      operation: Operation.like,
    },
  ];

  const onExport: ExportData = {
    data: () => excelData(),
    fileName: `Terminations Report - ${new Date().toLocaleDateString()}`,
  };

  const excelData = async () => {
    queryStrings.set("size", (0).toString());

    const res = await httpService(ENDPIONTS.terminations, queryStrings).getAll();
    if (res.status === 200) {
      return (res.data as PaginatedResult<Termination>)?.items;
    }

    return [];
  };

  const onPrint = (element: HTMLElement) => {
    var subElement = element.querySelectorAll(":scope > div")[0];
    subElement.classList.remove("d-none");

    var subElement02 = element.querySelectorAll(":scope > div")[1];
    subElement02.classList.add("d-none");

    let table = element.getElementsByTagName("table")[0];
    table.classList.remove("table-striped");
  };

  const handlePageChange = (page: number, size: number) => {
    queryStrings.set("size", size.toString());
    queryStrings.set("page", (page - 1).toString());

    navigate({ search: `?${queryStrings.toString()}` });
  };

  return (
    <div className="content container-fluid">
      <div className="row align-items-center">
        <div className="d-flex justify-content-between mb-1">
          <div className="col-4">
            <h3 className="page-title">Terminations Report</h3>
          </div>
        </div>
      </div>

      <div className="col-12 mt-3" id="reportcontents">
        <PaperHeader title="Terminations Report" />
        <div className="row mb-3">
          <div className="col-auto float-end ms-auto">
            <TableVerticalConfigs
              filters={filters}
              exportAsXSLS={onExport}
              onPrint={{
                ref: "reportcontents",
                prePrint: onPrint,
              }}
            />
          </div>
        </div>
        <Table
          class="table table-striped table-hover mb-0"
          actions={actions}
          data={fetchData?.data ?? []}
          headers={headers}
          isFetchingPage={fetchData.isFetching}
          showCounter
          onPageChange={handlePageChange}
          paginationClass="row mt-3"
        />
      </div>
    </div>
  );
};

export default ListTerminations;
